import { bool, func, node, number, oneOfType, string } from 'prop-types';
import React from 'react';
import Icon from '../Icon/index';
import css from '@styled-system/css'
import styled from '@emotion/styled';

const StyledSelect = styled('select')(
  css({
    borderRadius: "input",
    paddingRight: "10px",
    paddingLeft: "10px",
    outline: "none",
    boxShadow: "none",
    border: "none",
    fontSize: "input",
    justifyContent: "center",
    alignItems: "center",
    background: "transparent",
  }), ({ width, height, theme, error, disabled }) => ({
    width,
    height,
    border: `1px solid ${error ? theme.colors.borderError : theme.colors.border}`,
    ":not(:focus-within):hover": {
      border: `1px solid ${theme.colors.borderActive}`
    },
    ":focus-within": {
      outline: "none",
      borderColor: theme.colors.borderFocus,
      boxShadow: `inset 0 0 0 1px ${theme.colors.borderFocus}`
    },
    cursor: disabled ? "not-allowed" : "default",
    backgroundColor: disabled ? theme.colors.backgroundDisabled : "white",
    appearance: "none",
  })
);

const StyledDiv = styled('div')({
  "svg": {
    position: "relative",
    right: "25px",
    top: "1px"
  }
});

const Select = ({
  children,
  onChange,
  value,
  className,
  error,
  width = "auto",
  height = "40px",
  disabled,
  ...rest
}) => (
    <StyledDiv>
      <StyledSelect
        error={error}
        width={width}
        height={height}
        disabled={disabled}
        value={value}
        onChange={onChange}
        {...rest}
      >
        {children}
      </StyledSelect>
      <Icon name="arrow-down" size="12" />
    </StyledDiv>
  );

export default Select;

Select.propTypes = {
  children: node.isRequired,
  onChange: func,
  value: oneOfType([string, number]),
  className: oneOfType([string, number]),
  error: oneOfType([bool, string]),
  height: string,
  disabled: bool,
};

